var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSellerName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7664,
    cy: 24.7664,
    r: 24.7664,
    fill: "#CB202D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 33.144H31V29.9297C30.9987 28.7366 30.5558 27.5928 29.7684 26.7492C28.9811 25.9056 27.9135 25.431 26.8 25.4297H23.2C22.0865 25.431 21.0189 25.9056 20.2316 26.7492C19.4442 27.5928 19.0013 28.7366 19 29.9297V33.144Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7144 20.2857C20.7144 21.1333 20.9657 21.9619 21.4366 22.6667C21.9075 23.3715 22.5769 23.9208 23.36 24.2452C24.1431 24.5696 25.0048 24.6544 25.8362 24.4891C26.6675 24.3237 27.4312 23.9155 28.0305 23.3162C28.6299 22.7168 29.0381 21.9532 29.2034 21.1218C29.3688 20.2905 29.2839 19.4288 28.9596 18.6456C28.6352 17.8625 28.0859 17.1932 27.3811 16.7223C26.6763 16.2514 25.8477 16 25.0001 16C23.8634 16 22.7733 16.4515 21.9696 17.2553C21.1659 18.059 20.7144 19.1491 20.7144 20.2857Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellerName);
export default __webpack_public_path__ + "static/media/SellerName.e9ecd9eeb98f04922c5c66719f870145.svg";
export { ForwardRef as ReactComponent };